import { useEffect, useState } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { CheckCircle2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useApp } from "../context/AppContext";
import { Button } from "../components/ui/button";
import { HealthFormBody } from "./public/HealthForm";
import ConsentSign from "./public/ConsentSign";

const TXT = {
  en: { done: "All done, thank you!", hand: "Please hand the device back to the clinic.", next: "Next", step: "Step", of: "of", none: "Nothing to fill in: everything is already up to date." },
  it: { done: "Tutto fatto, grazie!", hand: "Restituisci il dispositivo alla clinica.", next: "Avanti", step: "Passo", of: "di", none: "Niente da compilare: è tutto aggiornato." },
};

export default function CheckIn() {
  const { cid } = useParams();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { user } = useApp();
  const [d, setD] = useState(null);
  const [i, setI] = useState(0);
  const [stepDone, setStepDone] = useState(false);
  useEffect(() => {
    if (!user) return;
    api.post(`/clients/${cid}/checkin`, { appointment_id: params.get("appt") || "" }).then((r) => setD(r.data)).catch((e) => { toast.error(errMsg(e)); nav(-1); });
  }, [cid, user]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d) return <div className="min-h-screen grid place-items-center text-muted-foreground">…</div>;
  const l = TXT[d.language] || TXT.en;
  const step = d.steps[i];
  const back = <button data-testid="checkin-exit-btn" onClick={() => nav(`/app/clients/${cid}`)} className="text-xs text-muted-foreground flex items-center gap-1"><ArrowLeft className="h-3.5 w-3.5" />Staff: exit check-in</button>;
  if (!step) {
    return (
      <div className="min-h-screen grid place-items-center p-6 text-center" data-testid="checkin-done">
        <div className="space-y-4"><CheckCircle2 className="h-16 w-16 text-primary mx-auto" />
          <h1 className="text-3xl font-bold">{d.steps.length ? l.done : l.none}</h1><p className="text-muted-foreground">{l.hand}</p>{back}</div>
      </div>
    );
  }
  const next = () => { setStepDone(false); setI(i + 1); window.scrollTo(0, 0); };
  return (
    <div className="min-h-screen bg-background" data-testid="checkin-page">
      <div className="max-w-3xl mx-auto p-4 sm:p-8 space-y-6">
        <div className="flex items-center justify-between gap-3">
          <p className="text-sm text-muted-foreground" data-testid="checkin-progress">{d.client_name} · {l.step} {i + 1} {l.of} {d.steps.length}: {step.name}</p>{back}
        </div>
        {step.type === "health" ? <HealthFormBody key={step.token} token={step.token} embedded onDone={() => setStepDone(true)} />
          : <ConsentSign key={step.token} token={step.token} onDone={() => setStepDone(true)} />}
        {stepDone && <Button className="w-full rounded-full h-12" data-testid="checkin-next-btn" onClick={next}>{l.next}</Button>}
      </div>
    </div>
  );
}
